import { render, staticRenderFns } from "./Standart.vue?vue&type=template&id=6846ecb8&"
import script from "./Standart.vue?vue&type=script&lang=js&"
export * from "./Standart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports